import { LogLevel } from "./logger.types";

const ENV = process.env.NEXT_PUBLIC_ENV;

export type Log = {
	source: string;
	operation: string;
	message: string;
	timestamp?: string;
	level?: LogLevel;
};

const writeLog = (log: Log) => {
	const jsonStringLog = JSON.stringify(log);
	switch (log.level) {
		case LogLevel.DEBUG:
			if (ENV !== "production") {
				console.info(
					`[${log.level}: ${log.timestamp}]: ${jsonStringLog}`,
				);
			}
			break;

		case LogLevel.INFO:
			console.info(`[${log.level}: ${log.timestamp}]: ${jsonStringLog}`);
			break;

		case LogLevel.WARN:
			console.warn(`[${log.level}: ${log.timestamp}]: ${jsonStringLog}`);
			break;

		case LogLevel.ERROR:
			console.error(`[${log.level}: ${log.timestamp}]: ${jsonStringLog}`);
			break;
	}
};

const handleLog = (log: Log) =>
	writeLog({ ...log, timestamp: new Date().toISOString() });

export const logger = (log: Log, level: LogLevel) =>
	handleLog({ ...log, level });
